 jQuery(document).ready(function () { 
    jQuery('.newsletter-form__button ').on('click', function(e) {
            jQuery('.error_msg').remove();
            jQuery('.newsletter-form__message--success').hide();
            var email = jQuery('.field__input').val();
            if (email === '') {
                e.preventDefault();  // Prevent form submission
                jQuery('.field__input').addClass('error');  // Add error class to input field
                jQuery('<span class="error_msg">This field is required</span>').insertAfter('.newsletter-form__field-wrapper');  // Display error message
            } else {
                if (validateEmail(email)) {
                jQuery('.field__input').removeClass('error');  // Remove error class if email is valid
                } else {
                    e.preventDefault();  // Prevent form submission
                jQuery('.field__input').addClass('error');  // Add error class to input field
                    jQuery('<span class="error_msg">Please enter a valid email address.</span>').insertAfter('.newsletter-form__field-wrapper');  // Display error message
                }
            }
        });
        // Email validation function
        function validateEmail(email) {
            var re = /\S+@\S+\.\S+/;
            return re.test(email);
        }

      var scrollBtn = document.getElementById("scrollToTopBtn");

  window.onscroll = function () {
    if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
      scrollBtn.style.display = "block";
    } else {
      scrollBtn.style.display = "none";
    }
  };

  scrollBtn.onclick = function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  jQuery('.localization-selector').on('click',function(){
    jQuery('.localization-selector').toggleClass('open');
});
//================ focus js ==============
   jQuery('input,textarea').on('focus', function() {
    jQuery(this).parent().addClass('has-focus');
  });

  jQuery('input,textarea').on('focusout', function() {
    if(jQuery(this).val() == '') {
      jQuery(this).parent().removeClass('has-focus');
    }
  }); 

   jQuery('input, textarea').each(function() {
    if (jQuery(this).val().trim() !== '') {
     jQuery(this).parent().addClass('has-focus');
    }
  }); 
  
  //=============================
  jQuery('#HeaderMenu-faqs').on('click', function(e){
      e.preventDefault(); // Stop default link action

      jQuery('html, body').animate({
          scrollTop: jQuery('.faq-section').offset().top - 100
      }, 600); // 600 = scroll speed
   });

     jQuery('#HeaderDrawer-faqs').on('click', function(e){
      e.preventDefault(); // Stop default link action
      jQuery('.menu-drawer-container').removeClass('menu-opening');
      jQuery('body').removeClass('overflow-hidden-tablet');
      jQuery('html, body').animate({
          scrollTop: jQuery('.faq-section').offset().top - 100
      }, 600); // 600 = scroll speed
   });
});   

// Shopify AJAX add to cart example
function addToCart(productId, quantity) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: [{
        id: productId,
        quantity: quantity
      }]
    })
  })
  .then(response => response.json())
  .then(cart => {
    // Update cart item count dynamically
    updateCartItemCount(cart.item_count);
  })
  .catch(error => {
    console.error("Error adding to cart:", error);
  });
}